import {
  ISearchWarehouse,
  Warehouse,
  WarehouseGrid
} from '../../interfaces/Warehouse/Warehouse'
import { searchInitialState } from './warehouseConfig'

interface Filter {
  key: string
  value: string
}

type State<Type, GridType, SearchType> = {
  open: boolean
  openDelete: boolean
  openView: boolean
  openRedireccion: boolean
  page: number
  rowsPerPage: number
  totalItems: number
  editableItem: Type | undefined
  openSnackbar: boolean
  messageColor: string
  messageStatus: string
  rows: GridType
  busqueda: SearchType
  gridStatus: string
  gridError: string
  filters: Filter[]
  idForDelete: number | undefined
  isLoading: boolean
}

type Action<Type, GridType, SearchType> =
  | { type: 'SWITCH_MODAL'; payload: boolean }
  | { type: 'SWITCH_MODAL_DELETE'; payload: boolean }
  | { type: 'SWITCH_MODAL_VIEW'; payload: boolean }
  | { type: 'SWITCH_MODAL_REDIRECCION'; payload: boolean }
  | { type: 'CHANGE_PAGE'; payload: number }
  | { type: 'SET_ID_FOR_DELETE'; payload: number | undefined }
  | { type: 'CHANGE_PAGE_SIZE'; payload: number }
  | { type: 'SET_TOTAL_ITEMS'; payload: number }
  | { type: 'SWITCH_EDITABLE_ITEM'; payload: Type | undefined }
  | { type: 'SWITCH_SNACKBAR'; payload: boolean }
  | { type: 'SET_MESSAGE_COLOR'; payload: string }
  | { type: 'SET_MESSAGE_STATUS'; payload: string }
  | { type: 'SET_ROWS'; payload: GridType }
  | { type: 'SET_PRODUCTO_ROWS'; payload: Type[] }
  | { type: 'SET_BUSQUEDA'; payload: SearchType }
  | { type: 'SET_GRID_STATUS'; payload: string }
  | { type: 'SET_GRID_ERROR'; payload: string }
  | { type: 'SET_FILTERS'; payload: Filter[] }
  | { type: 'SET_IS_LOADING'; payload: false }

export const reducerInitialState = {
  open: false,
  idForDelete: undefined,
  openDelete: false,
  openView: false,
  openRedireccion: false,
  page: 0,
  rowsPerPage: 5,
  totalItems: 0,
  editableItem: {
    id: 0,
    warehouseCode: '',
    postalCode: '',
    warehouseDescription: '',
    zones: [],
    zoneId: 0,
    warehouseAddress: '',
    warehouseName: '',
    warehouseSchedule: [],
    active: false
  },
  openSnackbar: false,
  messageColor: '',
  messageStatus: '',
  rows: [],
  busqueda: searchInitialState,
  gridStatus: 'terminado',
  gridError: '',
  filters: [],
  isLoading: false
}

export const almacenReducer = (
  state: State<Warehouse, WarehouseGrid[], ISearchWarehouse>,
  action: Action<Warehouse, WarehouseGrid[], ISearchWarehouse>
) => {
  switch (action.type) {
    case 'SWITCH_MODAL':
      return {
        ...state,
        open: action.payload
      }
    case 'SWITCH_MODAL_DELETE':
      return {
        ...state,
        openDelete: action.payload
      }
    case 'SWITCH_MODAL_VIEW':
      return {
        ...state,
        openView: action.payload
      }
    case 'SWITCH_MODAL_REDIRECCION':
      return {
        ...state,
        openRedireccion: action.payload
      }
    case 'CHANGE_PAGE':
      return {
        ...state,
        page: action.payload
      }
    case 'CHANGE_PAGE_SIZE':
      return {
        ...state,
        rowsPerPage: action.payload
      }
    case 'SET_TOTAL_ITEMS':
      return {
        ...state,
        totalItems: action.payload
      }
    case 'SWITCH_EDITABLE_ITEM':
      return {
        ...state,
        editableItem: action.payload
      }
    case 'SWITCH_SNACKBAR':
      return {
        ...state,
        openSnackbar: action.payload
      }
    case 'SET_MESSAGE_COLOR':
      return {
        ...state,
        messageColor: action.payload
      }
    case 'SET_MESSAGE_STATUS':
      return {
        ...state,
        messageStatus: action.payload
      }
    case 'SET_ROWS':
      return {
        ...state,
        rows: action.payload
      }
    case 'SET_PRODUCTO_ROWS':
      return {
        ...state,
        rows: action.payload
      }
    case 'SET_BUSQUEDA': {
      return {
        ...state,
        busqueda: action.payload
      }
    }
    case 'SET_ID_FOR_DELETE': {
      return {
        ...state,
        idForDelete: action.payload
      }
    }
    case 'SET_GRID_STATUS': {
      return {
        ...state,
        gridStatus: action.payload
      }
    }
    case 'SET_GRID_ERROR': {
      return {
        ...state,
        gridError: action.payload
      }
    }
    case 'SET_FILTERS': {
      return {
        ...state,
        filters: action.payload
      }
    }
    case 'SET_IS_LOADING': {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    default:
      return state
  }
}
